var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tms-dashboard" }, [
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "nav-bar-container" }, [
        _c("div", { staticClass: "nav-bar clearfix" }, [
          _c("div", { staticClass: "welcome" }, [
            _c("span", { staticClass: "summary-hello" }, [
              _vm._v(_vm._s(_vm.$t("hello"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "summary-name" }, [
              _vm._v(
                _vm._s(
                  (_vm.currentUserContact || {}).name || _vm.currentUser.name
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "summary-items" }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tenant-dashboard__wrapper" },
        [
          _c("DynamicTabsContainer", {
            key: _vm.componentKey,
            attrs: { tabTemplates: _vm.shouldRenderTabTemplates },
            on: { tabClick: _vm.replaceRouteWithTabIndex },
            scopedSlots: _vm._u(
              [
                _vm.hotbTabPinIndex !== -1 && _vm.showHotbTabPin
                  ? {
                      key: "icon-" + _vm.hotbTabPinIndex,
                      fn: function () {
                        return [_c("HKLPinBadge", { attrs: { inline: true } })]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.fitoutTabPinIndex !== -1 && _vm.showFitoutTabPin
                  ? {
                      key: "icon-" + _vm.fitoutTabPinIndex,
                      fn: function () {
                        return [_c("HKLPinBadge", { attrs: { inline: true } })]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.directoryTabPinIndex !== -1 && _vm.showDirectoryTabPin
                  ? {
                      key: "icon-" + _vm.directoryTabPinIndex,
                      fn: function () {
                        return [_c("HKLPinBadge", { attrs: { inline: true } })]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }